import React, { useEffect, useState } from 'react';

import { 
  Character,
  CharacterSheetInterface,
} from "@dndModels";
import { isSizeType } from "@dndModels/Types";
import { SIZE_MAP, SIZE_OPTIONS } from "@dndModels/Constants";

import CommonUtilities from "@utilities/common_utilities";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import FlexBox from '@components/layout/FlexBox';
// import FloatMenu from '../../../../../components/input/menus/FloatMenu';

interface Props {
  char: Character;
  char_int?: CharacterSheetInterface;
  disabled?: boolean;
  // onChange: () => void;
}

const common_util = CommonUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterSizeCustomizations({ 
  char,
  char_int,
  disabled = false,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [override_size, setOverrideSize] = useState(char.customizations.overrides.size === undefined ? "Don't Override" : common_util.size_map[char.customizations.overrides.size]);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <FlexBox direction="row" className="padded">
      <FlexBox xs_expand={0} className="centered" style={{ width: "33%" }} direction="column">
        <FlexBox xs_expand={0} className="header">
          Override Base Size: 
        </FlexBox>
        <FlexBox xs_expand={0} className="small_label gray">
          Currently { SIZE_MAP[char.base_size] }
        </FlexBox>
      </FlexBox>
      <FlexBox>
        <SelectStringBox 
          name="Choose a Size"
          options={SIZE_OPTIONS}
          extra_options={["Don't Override"]}
          value={ override_size } 
          disabled={ disabled }
          onChange={ async (changed: string) => {
            setOverrideSize(changed);
            if (changed === "Don't Override") {
              delete char.customizations.overrides.size;
            } else {
              const size = +changed;
              if (isSizeType(size)) {
                char.customizations.overrides.size = size;
              }
            }
            char.changed();
            char.subscription_holder.recalculate();
          }}
        />
      </FlexBox>
    </FlexBox>
  );
}
